import React from "react";
import { Container } from "./styles";

const MessageError = ({ message, ...rest }) => (
  <Container {...rest}>{message}</Container>
);

export default MessageError;
